import { MealType, Recipe } from '../types/mealPlan';

/**
 * Which recipes belong under each meal filter, shared by the cookbook swap
 * drawer and the cookbook/archive pages.
 *
 * Slots are authoritative when present: they say exactly where the planner
 * (and so these filters) should offer a recipe, and a spanning chili shows
 * under both Lunch and Dinner. Recipes without slots (user creations and
 * imports the backfill left alone) fall back to course heuristics, with
 * untagged treated as dinner (legacy recipes are overwhelmingly dinner
 * mains). "lunch" as a course is legacy tolerance only.
 */
export const MEAL_SLOT_MATCHERS: Record<
  Exclude<MealType, never>,
  (recipe: Recipe) => boolean
> = {
  breakfast: (r) => (r.slots ? !!r.slots.breakfast : r.category === 'breakfast'),
  lunch: (r) =>
    r.slots
      ? !!r.slots.lunch
      : ['lunch', 'salad', 'soup'].includes(r.category ?? ''),
  dinner: (r) =>
    r.slots
      ? !!r.slots.dinner
      : !r.category || ['main_dish', 'soup', 'salad'].includes(r.category),
};
